export const TypesTabEmployee = {
  Activos: 0,
  Destacados: 1,
  Retirados: 2,
};
